function calendarDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || "")) throw new Error("A report date is required.");
  const timestamp = Date.parse(`${value}T00:00:00Z`);
  if (!Number.isFinite(timestamp) || new Date(timestamp).toISOString().slice(0, 10) !== value) {
    throw new Error("The report date is invalid.");
  }
  return timestamp;
}

function midnight(date, timeZone) {
  const nominal = calendarDate(date);
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone, year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23",
  });
  let timestamp = nominal;
  for (let i = 0; i < 4; i += 1) {
    const parts = Object.fromEntries(formatter.formatToParts(timestamp).map(p => [p.type, p.value]));
    const localAsUTC = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day),
      Number(parts.hour), Number(parts.minute), Number(parts.second));
    if (localAsUTC === nominal) return new Date(timestamp).toISOString();
    timestamp += nominal - localAsUTC;
  }
  throw new Error("The job timezone could not resolve this report day.");
}

export function jobDayRange(reportDate, timeZone) {
  if (!timeZone) throw new Error("Set the job timezone before loading dated report notes.");
  const followingDate = new Date(calendarDate(reportDate) + 86400000).toISOString().slice(0, 10);
  return { start: midnight(reportDate, timeZone), end: midnight(followingDate, timeZone) };
}
